import React, { useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

function PrivacyPolicy() {
  const [ref, isVisible] = useScrollAnimation(0.1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={`privacy-policy fade-in-up ${isVisible ? 'visible' : ''}`} ref={ref}>
      <div className="container">
        <h1>מדיניות פרטיות – אפליקציית Reado</h1>
        <p className="update-date">עודכן לאחרונה בתאריך: 08/08/2026</p>

        <div className="privacy-content">
          <p>אנו, ב-Reado, מכבדים את פרטיותך ומתחייבים להגן על המידע האישי שאתה מוסר לנו. מסמך זה נועד להבהיר אילו נתונים אנו אוספים, כיצד אנו עושים בהם שימוש, ואילו זכויות עומדות לרשותך בנוגע למידע זה.</p>

          <section>
            <h2>1. מי אנחנו</h2>
            <p>Reado מופעלת על ידי רז קליין, עוסק פטור, מס' עוסק 212609481, כתובת: קוממיות 9, מגדל העמק, טלפון: 053-5272518, דוא"ל: reado.il.service@gmail.com. המפעיל הוא בעל המאגר ובעל השליטה במידע (Data Controller).</p>
          </section>

          <section>
            <h2>2. סוגי המידע שאנו אוספים</h2>
            <h3>2.1 מידע שמוסר המשתמש באופן יזום:</h3>
            <ul>
              <li>שם פרטי (אם נמסר).</li>
              <li>כתובת דוא"ל.</li>
              <li>נתונים שמוזנים בשאלון ההיכרות.</li>
              <li>מידע שנרשם במסגרת תרגול וכתיבת משימות.</li>
              <li>משוב או פניות ששלחת אלינו.</li>
              <li>סטטוס מנוי וחיוב (נשמר מול ספק ניהול המנויים — RevenueCat — ואינו כולל פרטי כרטיס אשראי או אמצעי תשלום).</li>
            </ul>
            <h3>2.2 מידע שנאסף אוטומטית:</h3>
            <ul>
              <li>נתוני שימוש באפליקציה (שלבים שהושלמו, זמן שימוש, סטטיסטיקות).</li>
              <li>כתובת IP ומידע על מכשיר/מערכת הפעלה.</li>
              <li>שימוש בקבצי Cookies, אסימוני התקנה ומזהי מכשיר (ראו סעיף 13).</li>
            </ul>
          </section>

          <section>
            <h2>3. מטרות השימוש במידע ובסיס חוקי</h2>
            <ul>
              <li>לאפשר שימוש תקין באפליקציה והתאמת חוויית המשתמש.</li>
              <li>להציג סטטיסטיקות התקדמות אישיות.</li>
              <li>לספק תמיכה טכנית.</li>
              <li>לשפר ולתחזק את השירות.</li>
              <li>שליחת עדכונים ומידע שיווקי (אם ניתנה לכך הסכמה).</li>
              <li>עמידה בדרישות החוק.</li>
            </ul>
            <p>3.1. הבסיס החוקי לעיבוד המידע: ביצוע חוזה (אספקת השירות), הסכמת המשתמש (לדיוור שיווקי ולחלק מהנתונים האופציונליים), ואינטרס לגיטימי של המפעיל (שיפור השירות, מניעת הונאות וניצול לרעה).</p>
          </section>

          <section>
            <h2>4. שיתוף מידע עם צדדים שלישיים</h2>
            <p>4.1. Reado אינה מוכרת, שוכרת או מחליפה מידע אישי עם צדדים שלישיים לצרכים מסחריים. יחד עם זאת, אנו מעבירים מידע לספקי שירות חיוניים לצורך תפעול האפליקציה:</p>
            <ul>
              <li>Apple Inc. — לעיבוד תשלומי IAP ברכישת מנוי במכשירי iOS.</li>
              <li>Google LLC — לעיבוד תשלומי Google Play Billing ברכישת מנוי במכשירי Android.</li>
              <li>RevenueCat, Inc. (ארה"ב) — ניהול מנויים וסנכרון סטטוס חיוב.</li>
              <li>Supabase, Inc. — אחסון מסד נתונים ושירותי backend; שרתי הענן ממוקמים באזור האיחוד האירופי (eu-central-1).</li>
              <li>Expo, Inc. (ארה"ב) — תשתיות מובייל ושירותי התראות (push notifications).</li>
            </ul>
            <p>4.2. כל ספק פועל לפי תקני אבטחה מחמירים ובהתאם להסכמי עיבוד מידע (DPA) ככל שנדרש.</p>
          </section>

          <section>
            <h2>5. שליחת דיוור ועדכונים</h2>
            <p>5.1. ייתכן ונשלח אליך מיילים הכוללים עדכונים, הצעות או מידע שיווקי – אך ורק אם נתת הסכמה לכך במפורש בעת ההרשמה או לאחריה.</p>
            <p>5.2. תוכל להסיר את עצמך מרשימת התפוצה בכל עת באמצעות הקישור להסרה שמצורף לכל מייל.</p>
          </section>

          <section>
            <h2>6. אבטחת מידע</h2>
            <p>6.1. אנו מיישמים אמצעי אבטחה מקובלים בתעשייה לשם שמירה על המידע – כולל הצפנה, גיבויים, הגבלת גישה, וזיהוי משתמשים.</p>
            <p>6.2. אף על פי כן, לא ניתן להבטיח אבטחה מוחלטת של המידע. המשתמש מאשר כי הוא מודע לסיכון הקיים בשימוש במערכות אינטרנטיות.</p>
            <p>6.3. במקרה של אירוע אבטחה חמור (פריצה / גישה לא מורשית למידע אישי), נדווח לרשות הגנת הפרטיות בהתאם לחובות הדיווח הקבועות בתקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017, ונודיע למשתמשים הנפגעים בכפוף לדרישות החוק.</p>
          </section>

          <section>
            <h2>7. זכויות המשתמש על המידע</h2>
            <p>7.1. בהתאם לחוק הגנת הפרטיות, כל אדם זכאי לעיין במידע שנשמר עליו.</p>
            <p>7.2. ניתן לפנות אלינו בבקשה לעיין, לתקן או למחוק מידע אישי, באמצעות דוא"ל: reado.il.service@gmail.com.</p>
            <p>7.3. מחיקת חשבון תגרור מחיקה של כלל המידע הקשור לחשבון, בכפוף לחובות שמירת מידע לפי דין.</p>
            <p>7.4. מענה לבקשות עיון, תיקון או מחיקה יישלח בתוך 30 ימים מקבלת הפנייה (בהתאם לחוק הגנת הפרטיות).</p>
            <p>7.5. בנוסף, אתה זכאי לקבל את המידע האישי שלך בפורמט מובנה וקריא-מחשב לצורך העברה לשירות אחר (Data Portability), ולהתנגד לעיבודים מסוימים של המידע, בכפוף לדין החל.</p>
          </section>

          <section>
            <h2>8. שמירת מידע</h2>
            <p>8.1. כל עוד החשבון פעיל — המידע נשמר לצורך אספקת השירות.</p>
            <p>8.2. לאחר מחיקת חשבון — המידע האישי יימחק תוך 30 ימים, למעט מידע שחובה לשמור על פי חוק. בפרט, רישומי חיוב וחשבונאות יישמרו 7 שנים בהתאם לחובת ניהול ספרים.</p>
            <p>8.3. נתוני שימוש אנונימיים (סטטיסטיקות ללא יכולת זיהוי) עשויים להישמר ללא הגבלת זמן לצרכים מחקריים וסטטיסטיים.</p>
          </section>

          <section>
            <h2>9. העברת מידע מחוץ לישראל</h2>
            <p>9.1. חלק משירותי הענן ממוקמים מחוץ לישראל. הנתונים המרכזיים שלך (מסד הנתונים של Supabase) מאוחסנים באיחוד האירופי (eu-central-1), מדינה שמהווה אזור עם דיני הגנת פרטיות מקבילים לאלו של ישראל.</p>
            <p>9.2. ספקים נוספים (כגון Apple, Google, RevenueCat, Expo) עשויים לעבד מידע גם בארצות הברית או באזורים אחרים. במקרים אלה אנו מקפידים לעבוד עם ספקים המעניקים רמת הגנה דומה, או בכפוף ל-Standard Contractual Clauses של האיחוד האירופי.</p>
          </section>

          <section>
            <h2>10. שינוי במדיניות פרטיות</h2>
            <p>10.1. אנו שומרים את הזכות לעדכן את מדיניות הפרטיות מעת לעת.</p>
            <p>10.2. שינויים מהותיים (לרבות שינויים בסוגי המידע הנאסף, מטרות השימוש או הוספת צדדים שלישיים) יודעו למשתמש לפחות 14 ימים מראש בדוא"ל ו/או בהודעה באפליקציה, וייכנסו לתוקף רק לאחר תקופת ההתראה.</p>
            <p>10.3. שינויים שאינם מהותיים (תיקוני נוסח, הבהרות) יחולו מרגע פרסומם באפליקציה.</p>
          </section>

          <section>
            <h2>11. קטינים</h2>
            <p>11.1. מדיניות פרטיות זו אינה מיועדת למשתמשים מתחת לגיל 13. איננו אוספים ביודעין מידע אישי מילדים מתחת לגיל 13. אם נודע לנו שאספנו מידע כזה, נמחק אותו בהקדם האפשרי.</p>
            <p>11.2. משתמשים מתחת לגיל 18 נדרשים בהסכמת הורה או אפוטרופוס לפני מסירת מידע אישי או רכישת מנוי.</p>
            <p>11.3. הורים או אפוטרופוסים המבחינים שילדם מסר מידע אישי, מוזמנים ליצור קשר בכתובת הדוא"ל המופיעה בסעיף יצירת הקשר.</p>
          </section>

          <section>
            <h2>12. בינה מלאכותית ועיבוד אוטומטי</h2>
            <p>12.1. חלק מהתכנים והכלים באפליקציה מבוססים על בינה מלאכותית (AI). מערכות אלה משתמשות במידע שלך לצורך התאמת תוכן, סיכומים ותרגולים אישיים.</p>
            <p>12.2. החלטות AI באפליקציה אינן מהוות החלטות אוטומטיות בעלות השלכות משפטיות או דומות לגביך כמשתמש (כגון אישור אשראי, גיוס לעבודה וכד').</p>
            <p>12.3. תוכל לבקש הבהרה על אופן השימוש ב-AI במידע שלך באמצעות פנייה לכתובת הדוא"ל המופיעה בסעיף יצירת הקשר.</p>
          </section>

          <section>
            <h2>13. Cookies ומזהי מובייל</h2>
            <p>13.1. האפליקציה משתמשת באסימוני התקנה, מזהי מכשיר (כגון Apple IDFA או Android Advertising ID) וטכנולוגיות דומות לצורך תפעול בלבד (לדוגמה: זיהוי מכשיר להתראות push, סטטיסטיקות שימוש).</p>
            <p>13.2. איננו מבצעים מעקב צולב בין אפליקציות (Cross-App Tracking) לצרכי פרסום, ולכן איננו מבקשים הרשאת App Tracking Transparency (ATT) במכשירי iOS.</p>
            <p>13.3. ייתכן שצדדים שלישיים (כגון Apple, Google, Supabase) מציבים cookies או מזהים דומים במסגרת מתן השירותים שלהם, בהתאם למדיניות הפרטיות שלהם.</p>
          </section>

          <section>
            <h2>14. זכות לתלונה ברשות הגנת הפרטיות</h2>
            <p>בנוסף לפנייה אל המפעיל, אתה זכאי להגיש תלונה לרשות הגנת הפרטיות (Privacy Protection Authority) במשרד המשפטים, אם אתה סבור כי זכויותיך בנוגע לפרטיות הופרו. פרטים נוספים באתר הרשות: gov.il/he/Departments/privacy_protection_authority.</p>
          </section>

          <section>
            <h2>15. יצירת קשר</h2>
            <p>לכל שאלה, בירור או בקשה בנוגע לפרטיותך, ניתן לפנות אלינו:</p>
            <ul>
              <li>מייל: reado.il.service@gmail.com</li>
              <li>טלפון: 053-5272518</li>
              <li>כתובת: קוממיות 9, מגדל העמק</li>
            </ul>
          </section>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
